import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ServiceFunction } from '../../users';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-services-functions-filter',
  templateUrl: './service-functions-filter.component.html',
  styleUrls: ['./service-functions-filter.component.scss'],
  standalone: false,
})
export class ServiceFunctionsFilterComponent implements OnInit {
  isDisabledApplyFilterButton: boolean;

  @Input() isShowDisabled;
  @Input() functionSelected;
  @Input() functions;

  @Output() onChangeVisibleHiddenServiceFunctions = new EventEmitter<Event>();
  @Output() onApplyServiceFunctionsFilter = new EventEmitter<any>();
  @Output() onResetServiceFunctionsFilter = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  onChangeSelectedFunction(functionSelected: ServiceFunction) {
    this.functionSelected = functionSelected;
    this.checkDisabledApplyFilterButton();
  }

  onApplyFilter() {
    this.onApplyServiceFunctionsFilter.emit(this.functionSelected);
  }

  onResetFilter() {
    this.functionSelected = null;
    this.onResetServiceFunctionsFilter.emit();
    this.checkDisabledApplyFilterButton();
  }

  checkDisabledApplyFilterButton() {
    this.isDisabledApplyFilterButton = !!this.functionSelected;
  }
}
